import React, { useEffect, useRef, useState } from "react";
import { ChevronDownIcon } from "lucide-react";

const Dropdown = ({ label, options, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionSelect = (option) => {
    onSelect(option);
    setIsOpen(false);
  };
  
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative flex justify-end " ref={dropdownRef}>
      <button
        type="button"
        className="flex capitalize items-center justify-between w-44 px-4 py-2 text-sm font-medium text-white bg-black/20 border border-gray-300 rounded-md shadow-sm focus:outline-none"
        onClick={toggleDropdown}
      >
        {label?.label ? label?.label : label}
        <ChevronDownIcon
          className={`h-5 w-5 text-gray-400 transition-transform duration-200 ${
            isOpen ? "transform rotate-180" : ""
          }`}
        />
      </button>

      {isOpen && (
        <div className="absolute bottom-10 z-20 mt-2 w-full max-w-56 bg-black/90 text-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="py-1 max-h-48 overflow-y-auto">
            {options?.map((option, index) => (
              <div
                key={index}
                className="block px-4 py-2 text-sm text-white hover:bg-gray-100 hover:text-gray-900 "
                onClick={() => handleOptionSelect(option)}
              >
                {option.label}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Dropdown;
